var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"text-none",attrs:{"fab":"","small":"","icon":"","color":"grey"},on:{"click":function($event){return _vm.$emit('on-click')}}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("mdi-close")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }